import apiClient from './apiClient';
import { AllTrainingPlans, TrainingPlan, TrainingPlanSchema } from '../utils/planTypes';

export const createTrainingPlan = async (plan: TrainingPlan) => {
  try {
    const response = await apiClient.post("admin/trainingPlans/create", plan);
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(`Error while creating training plan: ${error}`);
  }
}

export const getTrainingPlan = async (): Promise<TrainingPlanSchema> => {
    try {
      const response = await apiClient.get("trainingPlans/user");
      const data = response.data as TrainingPlanSchema;
      return data;
    } catch (error) {
      throw new Error(`No plan found for user: ${error}`);
    }
};

export const getTrainingPlanNoBackup = async (): Promise<TrainingPlanSchema> => {
    try {
      const response = await apiClient.get("trainingPlans/user/no-backup");
      const data = response.data as TrainingPlanSchema;
      return data;
    } catch (error) {
      throw new Error(`No plan found for user: ${error}`);
    }
};

export const getTrainingPlanById = async (uuid: string): Promise<TrainingPlanSchema> => {
    try {
      const response = await apiClient.get(`trainingPlans/${uuid}`);
      const data = response.data as TrainingPlanSchema;
      return data;
    } catch (error) {
      throw new Error(`No plan found for user: ${error}`);
    }
};

export const getAllTrainingPlans = async (): Promise<AllTrainingPlans[]> => {
  try {
    const response = await apiClient.get("trainingPlans");
    const data = response.data as AllTrainingPlans[];
    return data;
  } catch (error) {
    throw new Error(`Error while fetching training plans: ${error}`);
  }
}

export const getAllCompleteTrainingPlans = async (): Promise<TrainingPlanSchema[]> => {
  try {
    const response = await apiClient.get("admin/trainingPlans");
    const data = response.data as TrainingPlanSchema[];
    return data;
  } catch (error) {
    throw new Error(`Error while fetching training plans: ${error}`);
  }
}

export const deleteTrainingPlan = async (uuid: string): Promise<{ message: string }> => {
  try {
    const response = await apiClient.delete(`admin/trainingPlans/${uuid}`);
    const data = response.data as { message: string };
    return data;
  } catch (error) {
    throw new Error(`Error while deleting training plan: ${error}`);
  }
}

export const updateTrainingPlan = async (uuid: string, plan: TrainingPlan): Promise<{ message: string }> => {
  try {
    const response = await apiClient.put(`admin/trainingPlans/${uuid}`, plan);
    const data = response.data as { message: string };
    return data;
  } catch (error) {
    throw new Error(`Error while updating training plan: ${error}`);
  }
}

export const duplicateTrainingPlan = async (uuid: string): Promise<{ plan_id: string; message: string }> => {
  try {
    const response = await apiClient.post(`admin/trainingPlans/${uuid}/duplicate`);
    const data = response.data as { plan_id: string; message: string };
    return data;
  } catch (error) {
    throw new Error(`Error while duplicating training plan: ${error}`);
  }
}
